import React from "react";

interface Props {
  className?: string;
  color?: string;
  size?: number;
}

const CircleIcon: React.FC<Props> = ({className, color, size = 24}) => (
  <svg width={size} height={size} className={className}>
    <path
      fill={color || "#9E9E9E"}
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z"
    />
  </svg>
);

export default CircleIcon;
